/* eslint-disable */
/**
 * 判断是否为外部资源
 * @param {*} path
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 判断是否为正确的 yyyy-MM-dd hh:mm:ss 格式
 * @param {*} time
 * @returns
 */
export function isTrueTimeType(rule, value, callback) {
    const reg =
        /^((\d{2}(([02468][048])|([13579][26]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|([1-2][0-9])))))|(\d{2}(([02468][1235679])|([13579][01345789]))[\-\/\s]?((((0?[13578])|(1[02]))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(3[01])))|(((0?[469])|(11))[\-\/\s]?((0?[1-9])|([1-2][0-9])|(30)))|(0?2[\-\/\s]?((0?[1-9])|(1[0-9])|(2[0-8]))))))(\s((([0-1][0-9])|(2?[0-3]))\:([0-5]?[0-9])((\s)|(\:([0-5]?[0-9])))))?$/
    if (value === '' || value === undefined || value == null) {
        callback()
    } else {
        if (value.length > 6) {
            if (!reg.test(value)) {
                callback(new Error('请输入正确的时间格式!'))
            } else {
                callback()
            }
        } else {
            callback(new Error('请输入正确的时间格式!'))
        }
    }
}

export function timeFormat(minute) {
    //60000毫秒 代表1分钟
    let state = new Date(new Date().getTime() - minute * 60000),
        date = new Date(state),
        hovers = date.getHours(),
        minutes = date.getMinutes(),
        seconds = date.getSeconds(),
        myDate = date.getDate()
    myDate < 10 ? (myDate = `0${myDate}`) : (myDate = myDate)
    hovers < 0 ? (hovers = `0${hovers}`) : (hovers = hovers)
    hovers < 10 ? (hovers = `0${hovers}`) : (hovers = hovers)
    minutes < 0 ? (minutes = `0${minutes}`) : (minutes = minutes)
    minutes < 10 ? (minutes = `0${minutes}`) : (minutes = minutes)
    seconds < 0 ? (seconds = `0${seconds}`) : (seconds = seconds)
    seconds < 10 ? (seconds = `0${seconds}`) : (seconds = seconds)

    //转换格式
    return `${date.getFullYear()}-${date.getMonth() + 1}-${myDate} ${hovers}:${minutes}:${seconds}`
}
